import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBrands } from "api/bandApi";

// Get Brands Action
export const getBrandsCall = createAsyncThunk(
    "filter/brands",
    async ({ header, formData, page }, { rejectWithValue }) => {
      try {
        const response = await getBrands(header, formData, page); // Call the API function
        return response; // Return the response on success
      } catch (error) {
        // Handle errors and pass custom error message from backend
        if (error.response && error.response.data) {
          return rejectWithValue(error.response.data);
        } else {
          return rejectWithValue(error); // Return the error if no response data
        }
      }
    }
  );